import * as Yup from 'yup';

const agentSchema = Yup.object().shape({
  name: Yup.string().required('Name is required.').min(2, 'Name must be at least 2 characters.'),
  email: Yup.string().email('Invalid email address.').required('Email is required.'),
  mobileNumber: Yup.string().required('Mobile Number is required.'),
  whatsappNumber: Yup.string(),
  password: Yup.string()
    .test('password-validation', function(value) {
      const { parent } = this;
      // If no id (creating new agent), password is required and must be at least 6 characters
      if (!parent.id) {
        if (!value || value.trim() === '') {
          return this.createError({ message: 'Password is required.' });
        }
        if (value.length < 6) {
          return this.createError({ message: 'Password must be at least 6 characters.' });
        }
      } else {
        // If id exists (editing), password is optional, but if provided must be at least 6 characters
        if (value && value.trim() !== '' && value.length < 6) {
          return this.createError({ message: 'Password must be at least 6 characters if provided.' });
        }
      }
      return true;
    }),
  countryCallingCode: Yup.string().required('Country Calling Code is required.'),
  countryCode: Yup.string().required('Country Code is required.'),
  language: Yup.string().required('Language is required.'),
  activeState: Yup.boolean(),
  photoId: Yup.string(),
  brokerLicenseId: Yup.string()
    .test('broker-license-required', function(value) {
      const { parent } = this;
      // Required when creating new agent (no id)
      if (!parent.id) {
        if (!value || value.trim() === '') {
          return this.createError({ message: 'Broker License is required.' });
        }
      }
      return true;
    }),
  idAttachmentId: Yup.string()
    .test('id-attachment-required', function(value) {
      const { parent } = this;
      // Required when creating new agent (no id)
      if (!parent.id) {
        if (!value || value.trim() === '') {
          return this.createError({ message: 'ID Attachment is required.' });
        }
      }
      return true;
    }),
});

export default agentSchema;

